import { render } from "./addEditWxUser.vue?vue&type=template&id=6a1f57cf"
import script from "./addEditWxUser.vue?vue&type=script&lang=js"
export * from "./addEditWxUser.vue?vue&type=script&lang=js"

import exportComponent from "E:\\源码\\baoxiu\\baoxiu\\VUE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__